import $ from 'jquery';
import ProductEvents from './product-events';

export default class TourDetailsEvents {
    constructor() {
        this.detailPage = '.ff-tours-finder';
        this.init();
    }

    init() {
        const $detailPage = $(this.detailPage);
        if ($detailPage.data('tour-id')) {
            const productEvent = new ProductEvents($detailPage.data('title'), $detailPage.data('tour-id'), 'tour_details_page');
            productEvent.productDetailEvent();
        }
    }
}
